import { useState } from "react";
import locale from "@bonliva-crm/locale";
import {
  DeleteContactPersonDialog_Deassign,
  DeleteContactPersonDialog_Delete
} from "@graphql";
import { store } from "@store";
import { OkCancelDialogOptions } from "@containers";

export function useHandleDeassign(contactPersonId: string, onDone: () => void, name) {
  const [loading, setLoading] = useState(false);

  function deassign(selectedIds: string[], allIds: string[]) {
    if (selectedIds.length === 0) {
      return;
    }

    const allSelected = selectedIds.length === allIds.length;
    return allSelected ? _delete() : _deassign(selectedIds);
  }

  function _deassign(customerIds: string[]) {
    setLoading(true);
    DeleteContactPersonDialog_Deassign.func({ contactPersonId, customerIds })
      .catch((e) => store().snackbars.error(`Cannot deassign\nReason: ${e}`))
      .then(() => store().snackbars.success(locale.ContactPersonDeassigned))
      .finally(() => {
        onDone();
        setLoading(false);
      });
  }

  function _delete() {
    setLoading(true);

    const options = new OkCancelDialogOptions();
    options.message = locale.DeleteContactPersonDesc(name);

    store()
      .ui.confirmDialog.confirm(options)
      .then((response) => {
        if (response !== "ok") {
          return;
        }

        return DeleteContactPersonDialog_Delete.func({ contactPersonId });
      })
      .catch((e) => store().snackbars.error(`Cannot delete contact person\nReason: ${e}`))
      .then(() => store().snackbars.success(locale.ContactPersonDeleted))
      .finally(() => {
        onDone();
        setLoading(false);
      });
  }

  return { loading, deassign };
}
